import React from 'react';
import { Button, ButtonClean, ConfirmModal, Skeleton, useModalContext, } from '@fourthwall/components';
import { GoogleAnalyticsIcon } from '@fourthwall/icons';
import { useGoogleAnalytics } from '../../hooks/useGoogleAnalytics';
import * as S from './GoogleAnalyticsBar.styled';
export const GoogleAnalyticsBar = () => {
    const { open } = useModalContext();
    const { data, isLoading, connectLink, onDisconnect } = useGoogleAnalytics();
    const status = data?.type;
    // TODO: Discuss and handle other statuses
    if (!status || isLoading) {
        return React.createElement(GoogleAnalyticsBarSkeleton, null);
    }
    const handleDisconnect = () => {
        open(ConfirmModal, {
            title: 'Are you sure you want to disconnect from Google Analytics?',
            confirmLabel: 'Yes, disconnect',
            confirmAppearance: 'destructive',
            onConfirm: onDisconnect,
        });
    };
    const getMainContent = () => {
        if (status === 'CONNECTED') {
            return (React.createElement(React.Fragment, null,
                data.email && React.createElement("div", null, data.email),
                React.createElement(ButtonClean, { appearance: "secondary", label: "Disconnect", onClick: handleDisconnect })));
        }
        return React.createElement(S.Info, null, "Connect Google Analytics to see visitors and other stats");
    };
    const renderActionButton = () => {
        const commonProps = {
            leftIcon: React.createElement(GoogleAnalyticsIcon, { width: 16, height: 16 }),
            size: 'xsmall',
        };
        if (status !== 'CONNECTED') {
            return React.createElement(Button, { ...commonProps, href: connectLink, label: "Connect" });
        }
        return (React.createElement(Button, { ...commonProps, label: "View", href: data.googleAnalyticsDashboardUri, target: "_blank" }));
    };
    return (React.createElement(S.Container, null,
        React.createElement(S.MainContent, null, getMainContent()),
        React.createElement(S.Actions, null, renderActionButton())));
};
export const GoogleAnalyticsBarSkeleton = () => {
    return (React.createElement(Skeleton, null,
        React.createElement(Skeleton.Shape, { width: 290, height: 40 })));
};
